import { render } from "./SubiektDocuments.vue?vue&type=template&id=de9b8dd4&scoped=true"
import script from "./SubiektDocuments.vue?vue&type=script&lang=js"
export * from "./SubiektDocuments.vue?vue&type=script&lang=js"

import "./SubiektDocuments.vue?vue&type=style&index=0&id=de9b8dd4&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9b8dd4"]])

export default __exports__